import { render, staticRenderFns } from "./noLive.vue?vue&type=template&id=7091987e&scoped=true&"
import script from "./noLive.vue?vue&type=script&lang=js&"
export * from "./noLive.vue?vue&type=script&lang=js&"
import style0 from "./noLive.vue?vue&type=style&index=0&id=7091987e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7091987e",
  null
  
)

export default component.exports